// require('dotenv').config();
const API_URL = process.env.REACT_APP_API_URL;
// const API_URL = ;
const pink = '#FF8AD8';
const white = '#FFFFFF';
const red = '#E72222';
const blue = '#1313C6';
const green = '#00CE8D';
const REMBOURSEMENT_LIMIT = 15;
const DEMANDE_LIMIT = 5;
const COLOR_TABLE = [
  '#FF8AD8',
  '#FF6722',
  '#1313C6',
  '#00CE8D',
  '#F7DA71',
  '#E72222',
  '#000000',
  '#000000'
];
const SERIES = ['seriesVisionGlobal', 'seriesPoste', 'seriesBeneficiary'];
const FAQ_URL = 'https://assistance.spvie.com/hc/fr';

const DEMANDE_COLOR = [
  {
    text: 'Non traité',
    color: '#E72222',
    status: 'WaitingLine'
  },
  {
    text: 'Élément manquant',
    color: '#E72222',
    status: 'MissingElement'
  },
  {
    text: 'En cours',
    color: '#FF6722',
    status: 'InProgess'
  },
  {
    text: 'Traité',
    color: '#00CE8D',
    status: 'Treated'
  }
];
const DEMANDE_FROM = [
  {
    from: 'VOUS',
    key: 'Client',
    color: '#00CE8D'
  },
  {
    from: 'SPVIE',
    key: 'SPVIE',
    color: '#1313C6'
  },
  {
    from: 'CGRM',
    key: 'CGRM',
    color: '#1313C6'
  }
];
const DEMANDE_HEADER = [
  {
    text: 'Date',
    sort: 'Created'
  },
  {
    text: 'Statut',
    sort: 'Status'
  },
  // {
  //   text: 'Durée traitement',
  //   sort: 'Type'
  // },
  {
    text: 'Demande',
    sort: 'CgrmQueue'
  },
  {
    text: 'Documents',
    sort: 'Count'
  }
];
export {
  API_URL,
  pink,
  white,
  red,
  blue,
  green,
  REMBOURSEMENT_LIMIT,
  DEMANDE_LIMIT,
  COLOR_TABLE,
  SERIES,
  FAQ_URL,
  DEMANDE_COLOR,
  DEMANDE_FROM,
  DEMANDE_HEADER
};
